import "./App.css";
import { useEffect, useState } from "react";
import Splash from "./components/splash/Splash";
import { NavLink, Route, Routes } from "react-router-dom";
import Summary from "./components/summary/Summary";
import ScoreCard from "./components/scoreCard/ScoreCard";
import Schedule from "./components/schedule/Schedule";
import AboutUs from "./components/aboutUs/AboutUs";
import GameSchedule from "./components/gameSchedule/GameSchedule";

function App() {
  const [isSplashVisible, setIsSplashVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsSplashVisible(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div style={{ height: "100%" }}>
      {isSplashVisible ? (
        <Splash />
      ) : (
        <div className="layout">
          <Routes>
            <Route path="/" element={<Summary />} />
            <Route path="/scorecard" element={<ScoreCard />} />

            <Route path="/schedule" >
            <Route path="" element={<Schedule/>} />
            <Route path="gameSchedule/:sport_row_id" element={<GameSchedule/>} />
            </Route>

            <Route path="/about" element={<AboutUs />} />
          </Routes>

          <div className="bottom-navigation">
            <NavLink to="/" className="nav-link">
              <span className="material-symbols-outlined">summarize</span>
              <p>Summary</p>
            </NavLink>

            <NavLink to="/scorecard" className="nav-link">
              <span className="material-symbols-outlined">scoreboard</span>
              <p>ScoreCard</p>
            </NavLink>

            <NavLink to="/schedule" className="nav-link">
              <span className="material-symbols-outlined">schedule</span>
              <p>Schedule </p>{" "}
            </NavLink>

            <NavLink to="/about" className="nav-link">
              <span className="material-symbols-outlined">import_contacts</span>
              <p>About</p>
            </NavLink>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
